<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Single or Multiple-->
<div class="DivBorder">
	<h4 class="Heading">Add Single or Multiple Lockers</h4>

	<div style="margin-bottom: 15px; text-align: center">
		<label>School:</label>
		<label class="InfoText" style="margin-left: 5px">{{ SchoolName }}</label>
	</div>

	<div class="RadioGrid2Col">
		<input [disabled]="IsLoading() == true" type="radio" id="Range" value="Range" name="LockerOption" [(ngModel)]="LockerOption" />
		<label for="Range">Add Range</label>

		<input [disabled]="IsLoading() == true" type="radio" id="Single" value="Single" name="LockerOption" [(ngModel)]="LockerOption" />
		<label for="Single">Add Single</label>
	</div>
</div>

<!--Add Multiple/Range-->
<div class="DivBorder TopMargin" *ngIf="LockerOption == 'Range'">
	<h4 class="Heading">Range of Lockers</h4>

	<div class="MultipleGrid">
		<label>Starting Locker Number:</label>
		<input type="number" class="form-control" min="0" [(ngModel)]="StartingLockerNum" />

		<label>Ending Locker Number:</label>
		<input type="number" class="form-control" min="0" [(ngModel)]="EndingLockerNum" />

		<label>Zero Padding:</label>
		<select [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="PaddingOptionID">
			<option *ngFor="let r of lstPaddingOption" [ngValue]="r.ID">
				{{ r.Desc }}
			</option>
		</select>

		<label>Add Letter(s) Before Number:</label>
		<input type="text" class="form-control" min="0" placeholder="Ex. 'A' creates A1, A2, etc." [(ngModel)]="AddLetterBefore" />

		<label>Add Letter(s) After Number:</label>
		<input type="text" class="form-control" min="0" placeholder="Ex. 'B' creates 1B, 2B, etc." [(ngModel)]="AddLetterAfter" />
	</div>
</div>

<!--Add Single-->
<div class="DivBorder TopMargin" *ngIf="LockerOption == 'Single'">
	<h4 class="Heading">Single Locker</h4>

	<div class="SingleGrid">
		<label>Locker Number:</label>
		<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="LockerNum" />

		<label>Assignable:</label>
		<input [disabled]="IsLoading() == true" class="form-control" type="checkbox" [(ngModel)]="Assignable" />

		<label>Locker Comments:</label>
		<textarea [disabled]="IsLoading() == true" class="form-control" [(ngModel)]="Comments"></textarea>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
